import React from 'react';

import burger from '../../../images/burger.svg';

import { FOHImage } from '../../ingredients';

export const FOHBurger = () => (
  <FOHImage source={{ uri: burger }} style={{ width: 18, height: 12 }} />
);
